import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ResourceCard extends ThemeComponent {
    /**
     * Initialise
     */
    init() {
    }
}
